'use client';

import { ResponsiveGridCarousel } from '@/components/shared/responsive-grid-carousel';
import type { Department } from '../../../../payload-types';
interface DepartmentHighlightsProps {
  highlights: Department['highlights'];
}
export const DepartmentHighlights = ({
  highlights
}: DepartmentHighlightsProps) => {
  if (!highlights) {
    return null;
  }
  return <ResponsiveGridCarousel items={highlights?.map(highlight => <div key={highlight.id} className="py-2 ">
          <h5 className="text-base md:text-xl mb-2 uppercase">{highlight.highlight}</h5>
          <p className="text-gray-800">{highlight.description}</p>
        </div>)} gridCols={{
    md: 2,
    lg: 4
  }} className="mb-16 md:mb-32" data-sentry-element="ResponsiveGridCarousel" data-sentry-component="DepartmentHighlights" data-sentry-source-file="department-highlights.tsx" />;
};